import { render } from "./_CatalogueSearch.vue?vue&type=template&id=c143e140"
import script from "./_CatalogueSearch.vue?vue&type=script&lang=js"
export * from "./_CatalogueSearch.vue?vue&type=script&lang=js"

import "./_CatalogueSearch.vue?vue&type=style&index=0&id=c143e140&lang=scss"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__